module.exports = __webpack_public_path__ + "static/media/WooCommerce_logo.5f36339b.svg";